"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var expressions = {
    EMAIL: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi,
    BR_TELEFONE: /(\d{4,5}-?\d{4})(?![a-zA-Z0-9]+)/,
    BR_TELEFONE_DDD: /(\(?\d{2}\)?\s?)?(\d{4,5}-?\d{4})(?![a-zA-Z0-9]+)/,
    BR_CEP: /^([\d]{2})\.?([\d]{3})-?([\d]{3})/,
    BR_CPF: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/,
    BR_CNPJ: /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/,
    BR_CPF_CNPJ: /(^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$)|(^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$)/,
    LOCALE_NUMBER: /(?=.)^\$?(\w?\W?)?(\s)?(([1-9][0-9]{0,2}([,.\s]?[0-9]{3})*)|[0-9]+)?([,.]?[0-9]{1,2})?$/,
    LOCALE_DATE: /[0-9]{2}\/[0-9]{2}\/[0-9]{4}|[1-9]{2}$/,
    LOCALE_TIME: /(([0-9]{2}:)*[0-9]+)?(\s?[\w|\W]+)/,
};
var isDefined = function (value) {
    return typeof value !== "undefined";
};
var isFilled = function (value) {
    return typeof value === "string" ? value.trim().length > 0 : isDefined(value);
};
var isInRange = function (value, limit1, limit2) {
    var min = Math.min(limit1, limit2);
    var max = Math.max(limit1, limit2);
    return value >= min && value <= max;
};
var verifyFormat = function (value, type, locale) {
    if (!isFilled(value))
        return false;
    var validateString = function (value, expression) {
        if (typeof value !== "string")
            return false;
        var match = value.match(expression);
        if (!match)
            return false;
        if (match.length > 0)
            return true;
        return false;
    };
    switch (type) {
        case "email": {
            return validateString(value, expressions.EMAIL);
        }
        case "date": {
            return validateString(value, expressions.LOCALE_DATE);
        }
        case "time": {
            return validateString(value, expressions.LOCALE_TIME);
        }
        case "integer":
        case "decimal": {
            if (typeof value === "number")
                validateString(value.toLocaleString(locale || "pt-br"), expressions.LOCALE_NUMBER);
            if (typeof value === "string")
                return validateString(value, expressions.LOCALE_NUMBER);
            break;
        }
        case "currency": {
            return validateString(value, expressions.LOCALE_NUMBER);
        }
        case "br-telefone": {
            return validateString(value, expressions.BR_TELEFONE);
        }
        case "br-telefone-ddd": {
            return validateString(value, expressions.BR_TELEFONE_DDD);
        }
        case "br-cep": {
            return validateString(value, expressions.BR_CEP);
        }
        case "br-cnpj": {
            return validateString(value, expressions.BR_CNPJ);
        }
        case "br-cpf": {
            return validateString(value, expressions.BR_CPF);
        }
        case "br-cpf-cnpj": {
            return validateString(value, expressions.BR_CPF_CNPJ);
        }
    }
    return false;
};
var checkFields = function (fields) {
    var errors = [];
    fields.forEach(function (field) {
        Object.keys(field).forEach(function (key) {
            var _a;
            if (!field[key])
                errors.push((_a = {}, _a[key] = field[key], _a));
        });
    });
    return errors;
};
var PPValidate = {
    isDefined: isDefined,
    isFilled: isFilled,
    isInRange: isInRange,
    verifyFormat: verifyFormat,
    checkFields: checkFields,
};
exports.default = PPValidate;
